import { httpsCallable } from "firebase/functions";
import { functions } from "../Firebase.js";
import { Users } from "../../models/User.tsx";
import { requestAgentSummaryRefresh } from "../../helpers/agentSummaryRefresh.tsx";
import { normalizeUserName, showUser } from "./UserService.tsx";

type DeletePlayerPayload = {
    id: string;
    userName: string;
    userType?: string;
};

/**
 * Calls the backend deletePlayerAndRelatedData function with the player
 * username and id. The Cloud Function hard-deletes the user and related data.
 */
export async function deletePlayerAndRelatedData(
    player: Pick<Users, 'id' | 'userName' | 'userType'>
): Promise<void> {
    if (player.userType && player.userType !== 'Player') {
        throw new Error('Only players can be deleted from Customer Admin');
    }

    const userName = normalizeUserName(player.userName ?? '');
    if (!userName) {
        throw new Error('Player username is required');
    }

    let userId = player.id;
    if (!userId) {
        const existing = await showUser(userName);
        userId = existing.id;
    }
    if (!userId) {
        throw new Error('Player not found');
    }

    const deletePlayer = httpsCallable<DeletePlayerPayload, { success: boolean }>(
        functions,
        'deletePlayerAndRelatedData'
    );

    await deletePlayer({
        id: userId,
        userName,
        userType: player.userType,
    });

    requestAgentSummaryRefresh();
}
